var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.591,
    height: 20.873,
    viewBox: "0 0 10.591 20.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123",
    transform: "translate(27.251 -0.708) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M11.165,26.751a1.614,1.614,0,0,1-1.1-.419L1.435,18.214a.6.6,0,0,1-.032-.805.6.6,0,0,1,.805-.032l8.634,8.119a.49.49,0,0,0,.644,0l8.634-8.119a.57.57,0,0,1,.773.838L12.26,26.3A1.652,1.652,0,0,1,11.165,26.751Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolver);
export default __webpack_public_path__ + "static/media/volver.2b1e47777ce9e9684340de5ef3f51402.svg";
export { ForwardRef as ReactComponent };